<template>
  <div>
    <span :class="`dialog-footer ${toRight ? 'float-right' : ''}`">
      <button
        :class="`btn btn-danger custom-shadow-btn ${classButton}`"
        @click="$emit('closeModal', modalName)"
      >
        {{ $t('common_words.cancel') }}</button
      >&nbsp;
      <button
        :class="`btn custom-btn-success custom-shadow-btn ${classButton}`"
        @click="$emit('validate')"
      >
        {{ labelButtonSuccess }}
      </button>
    </span>
  </div>
</template>
<script>
import i18n from 'src/i18n';
export default {
  name: 'dialog-button-form',
  props: {
    classButton: {
      type: String,
      default: '',
    },
    labelButtonSuccess: {
      type: String,
      default: i18n.t('common_words.save'),
    },
    modalName: {
      type: String,
      default: 'create',
    },
    toRight: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
